// extracted by mini-css-extract-plugin
export var adjacentSlide = "_mz-9";
export var arrowButtonContainer = "_mz-5";
export var arrowButtonIcon = "_mz-6";
export var carouselArrowButton = "_mz-2";
export var carouselElementContainer = "_mz-1";
export var currentSlide = "_mz-8";
export var left = "_mz-3";
export var otherSlide = "_mz-a";
export var productCarouselContainer = "_mz-0";
export var right = "_mz-4";
export var sliderOverflow = "_mz-7";